import React, { useEffect, useMemo, useState } from 'react'
import {
  Container,
  Row,
  Col,
  Form,
  Table,
  Button,
  Modal,
  Card,
} from 'react-bootstrap'
import axios from 'axios'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import Cookies from 'js-cookie'
import { Typeahead } from 'react-bootstrap-typeahead'
import { FaClipboardList } from 'react-icons/fa'
import {
  BsFunnelFill,
  BsSearch,
  BsArrowClockwise,
} from 'react-icons/bs'
import {
  LuGraduationCap,
} from 'react-icons/lu'
import toast from 'react-hot-toast'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'

export default function AddExamResult() {
  const {token, logout} = useAuth()
  const { isCollapsed } = useSidebar()
  const [showFilterCard, setShowFilterCard] = useState(true)
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();
  const [marginLeft, setMarginLeft] = useState('0px')

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  const { student_id, course_id, class_id } = useParams()
  console.log(
    'Type of student Id: ',
    typeof student_id,
    'Type of Course Id: ',
    typeof course_id,
    class_id,
    'Type of Class Id: ',
    typeof class_id,
  )
  const [courses, setCourses] = useState([])
  const [selectedCourse, setSelectedCourse] = useState('')
  const [exams, setExams] = useState([])
  const [selectedExams, setSelectedExams] = useState('')
  const [classes, setClasses] = useState([])
  const [selectedClass, setSelectedClass] = useState([])
  const [students, setStudents] = useState([])
  const [selectedStudent, setSelectedStudent] = useState('')
  const [openTable, setOpenTable] = useState(false)
  const [subjects, setSubjects] = useState([])
  const [formData, setFormData] = useState([])
  const [viewPreview, setViewPreview] = useState(false)
  const [selectedStudentName, setSelectedStudentName] = useState(false)
  const [disabledMarking, setDisabledMarking] = useState(false)
  const navigate = useNavigate()
  const {institute_id} = useAuth()
  const location = useLocation()
  const editExamData = useMemo(()=>{
    return location.state?.data || []
  },[location.state?.data])

  const selectedExamId = location.state?.selectedExamId
  console.log("Exam Data from Marksheet: ", editExamData)

  useEffect(() => {
    console.log("📌 Triggering formData setup useEffect");
    console.log("✅ editExamData:", editExamData);
    console.log("✅ subjects:", subjects.length);
    console.log("✅ selectedExamId:", selectedExamId);

    
    if (editExamData.length > 0 && subjects.length > 0 && selectedExamId) {
      const updatedFormData = subjects.map((sbj) => {
     
        const match = editExamData.find(
          (item) => item.subject_id === sbj.id && item.exam_id === selectedExamId
        )

        const marks = match?.marks ?? ''
        return {
          subject_id: sbj.id,
          subject_name: sbj.subject_name,
          result_id: match?.id || null,
          number: typeof marks === 'number' || !isNaN(marks) ? String(marks) : '',
          grade: isNaN(marks) ? marks : '',
          status: match?.status || '',
        }
      })
      setFormData(updatedFormData)
    }
  }, [editExamData, subjects, selectedExamId])


  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => {
      console.log('📌 All Courses:', res.data.data)
      setCourses(res.data.data)
    })
  }, [])

  useEffect(() => {
    if (course_id && courses.length > 0) {
      setSelectedCourse(course_id)
      handleCourseChange({ target: { value: course_id } })
    }
  }, [course_id, courses])

  useEffect(() => {
    if (class_id && classes.length > 0) {
      console.log(
        'Classes: ',
        courses,
        ' class_id: ',
        course_id,
        ' -> within useEffect',
      )
      setSelectedClass(Number(class_id))
      handleClassChange({ target: { value: class_id } })
    }
  }, [class_id, classes])

  // useEffect(() => {
  //   if (prevData.length > 0 && subjects.length > 0) {
  //     const updatedFormData = subjects.map((sbj) => {
  //       const match = prevData.find(
  //         (item) =>
  //           item.subject_id === sbj.id && item.exam_id === selectedExamId
  //       )
  
  //       const marks = match?.marks ?? ''
  
  //       return {
  //         subject_id: sbj.id,
  //         subject_name: sbj.subject_name,
  //         result_id: match?.id || null,
  //         number:
  //           typeof marks === 'number' || !isNaN(marks) ? String(marks) : '',
  //         grade: isNaN(marks) ? marks : '',
  //         status: match?.status || '',
  //       }
  //     })
  
  //     setFormData(updatedFormData)
  //   }
  // }, [prevData, subjects, selectedExamId])
  
  useEffect(() => {
    if (student_id && students.length > 0) {
      console.log(
        'Students: ',
        students,
        ' student_id: ',
        course_id,
        ' -> within useEffect',
      )
      const matchedStudent = students.find(
        (st) => Number(st.id) === Number(student_id),
      )
      setSelectedStudentName(matchedStudent?.name)
      if (matchedStudent) {
        setSelectedStudent(Number(student_id))
        // setSelectedStudentName(Number(student_id))
        handleStudentChange({ target: { value: student_id } })
      }
    }
  }, [student_id, students])

  useEffect(() => {
    if (subjects.length > 0 && (!editExamData || editExamData.length === 0)) {
      const initialForm = subjects.map((sbj) => ({
        subject_id: sbj.id,
        number: sbj.number || '',
        grade: sbj.grade || '',
        grade_number: sbj.number || sbj.grade || '',
        status: sbj.status || '',
      }))
      console.log('initialForm', initialForm)
      setFormData(initialForm)
    }
  }, [subjects, editExamData])

  // useEffect(() => {
  //   if (location.state?.data) {
  //     const incomingData = location.state.data
  
  //     // ✅ Ensure all subjects are loaded first
  //     if (subjects.length > 0) {
  //       const updatedFormData = subjects.map((sbj) => {
  //         const match = incomingData.find((item) => item.subject_id === sbj.id)
          
  //         return {
  //           subject_id: sbj.id,
  //           subject_name: sbj.subject_name,
  //           result_id: match?.id || null,
  //           number: match && !isNaN(match.marks) ? match.marks : '', // marks in number
  //           grade: match && isNaN(match.marks) ? match.marks : '',   // marks in grade
  //           status: match?.status || '',
  //         }
  //       })
  
  //       setFormData(updatedFormData)
  //     }
  //   }
  // }, [location.state, subjects])
  
  
  // useEffect(()=>{
  //   if(location.state?.data){
  //     const incomingData = location.state.data
  //     const transformed = incomingData.map((item)=>({
  //       result_id:item.id,
  //       subject_id:item.subject_id,
  //       number:item.number || "",
  //       grade: item.grade || "",
  //       status:item.status || "",
  //     }))
  //     setFormData(transformed)
  //   }
  // },[location.state])

  // useEffect(() => {
  //   if (location.state?.data?.length > 0) {
  //     const firstEntry = location.state.data[0]
  //     setSelectedCourse(firstEntry.course_id)
  //     setSelectedStudent(firstEntry.student_id)
  //     // setSelectedExams(firstEntry.exam_id)
  //     setOpenTable(true)
  //     setDisabledMarking(true)
  //   }
  // }, [location.state])
  useEffect(() => {
    if (selectedExamId) {
      setSelectedExams(selectedExamId)
    }
  }, [selectedExamId])
    
    const handleCourseChange = (e) => {
      const courseId = e.target.value
      console.log('courseId', courseId)
      setSelectedCourse(courseId)
      if (courseId) {
        ApiEndpoints.getAllClassesByCourseId(courseId).then((res) => {
          console.log('Classes after course:', res.data.data)
          setClasses(res.data.data)
        })
      }
      if (courseId) {
        axios
          .get(
            BASE_URL+`/get/all/exam-by-course?course_id=${courseId}`,
            {headers: { Authorization: `Bearer ${token}` }  }
          )
          .then((res) => {
            console.log('all exams after selected course:', res.data.data)
            setExams(res.data.data)
          })
      }
    
      if (courseId) {
        ApiEndpoints.getSubjectsByCourse(courseId).then((res) => {
          console.log('Subjects by course:', res.data.data)
          setSubjects(res.data.data)
        })
      }
    }

    const handleExamChange = (e) => {
      const examId = e.target.value
      console.log('✅ Selected Exam ID:', examId)
      setSelectedExams(examId)
      if (examId) {
        setOpenTable(true)
      }
    }

  const handleClassChange = (e) => {
    const classId = e.target.value
    console.log('Selected class:', classId)
    setSelectedClass(classId)
    if (classId) {
      const institueId = Cookies.get('institute_id')
      const headers = {
        'institute-Id': institueId || institute_id,
        Authorization: `Bearer ${token}`
      }
      axios
        .get(
          BASE_URL+`/get/student/by-class?class_id=${classId}`,
          { headers },
        )
        .then((res) => {
          console.log('List of Students:', res.data.data)
          setStudents(res.data.data)
        })
    }
  }

  // const handleStudentChange = async (e) => {
  //   const studentId = e.target.value
  //   console.log('✅ Selected Student ID:', studentId)
  //   setSelectedStudent(studentId)
  //   if(prevData?.student_id){
  //     setOpenTable(true)
  //   }
  //   // else if(prevData?.exam_id){
  //   //   setSelectedExams(null)
  //   //   setOpenTable(false)
  //   // }
  //   else{
  //     setOpenTable(true)
  //   }
   
  // }

  
  const handleStudentChange = async (e) => {
    const studentId = e.target.value
    console.log('✅ Selected Student ID:', studentId)
    setSelectedStudent(studentId)
    if(editExamData?.student_id){
      setOpenTable(true)
    }
    else{
      setOpenTable(true)
    }
   
  }

  const handleRefresh = () => {
    setSelectedCourse(null)
    setSelectedExams(null)
    setSelectedClass(null)
    setSelectedStudent(null)
    setSelectedStudentName(null)
    setDisabledMarking(false)
    setClasses([])
    setStudents([])
    setExams([])
    setSubjects([])
    setOpenTable(false)
  }

  const handleInputChange = (e, index, type) => {
    const { value } = e.target

    const updatedValue = value.trim()
    const updated = [...formData]
    const passingMarks = selectedExam?.passing_marks || ''
    const scheme = selectedExam?.marking_scheme

    // if(updatedValue === ""){
    //   updated[index]={
    //     number:"",
    //     grade:"",
    //     status:null
    //   }
    //   setFormData(updated)
    //   return
    // }
    let status = updated[index]?.status || null

    if (scheme === 'number') {
      status =
        parseFloat(updatedValue) >= parseFloat(passingMarks) ? 'pass' : 'fail'
      updated[index] = {
        ...updated[index],
        number: updatedValue,
        grade: '',
        status,
      }
    } else if (scheme === 'grade') {
      const gradeOrder = ['A+', 'A', 'B+', 'B', 'C', 'D', 'E', 'F']
      const inputIndex = gradeOrder.indexOf(updatedValue.toUpperCase())
      const passIndex = gradeOrder.indexOf(passingMarks.toUpperCase())

      status = inputIndex <= passIndex && inputIndex !== -1 ? 'pass' : 'fail'
      updated[index] = {
        ...updated[index],
        grade: updatedValue.toUpperCase(),
        number: '',
        status,
      }
    } else if (scheme === 'grade_number') {
      const num = parseFloat(updatedValue)
      const passByNumber = !isNaN(num) && num >= parseFloat(passingMarks)
      const grade = updatedValue.toUpperCase()
      const gradeOrder = ['A+', 'A', 'B+', 'B', 'C', 'D', 'E', 'F']
      const inputIndex = gradeOrder.indexOf(grade)
      const passIndex = gradeOrder.indexOf(passingMarks.toUpperCase())
      const passByGrade = inputIndex <= passIndex && inputIndex !== -1
      if (type === 'number') {
        updated[index] = {
          ...updated[index],
          number: updatedValue,
          grade: '',
          status: passByNumber ? 'pass' : 'fail',
        }
      } else {
        updated[index] = {
          ...updated[index],
          grade: grade,
          number: '',
          status: passByGrade ? 'pass' : 'fail',
        }
      }
    }
    setFormData(updated)
  }
  const handleToggle = (index) => {
    setFormData((prev) => {
      const updated = [...prev]
      const currentStatus = updated[index]?.status || 'pass' // default to pass
      updated[index] = {
        ...updated[index],
        status: currentStatus === 'pass' ? 'fail' : 'pass',
      }
      return updated
    })
  }
  
  const handleSubmit = async (e) => {
    e.preventDefault()
  
    try {
      const putData = []
      const postData = []
  
      formData.forEach((item) => {
        const marks = item.number || item.grade || item.grade_number || null
        const common = {
          exam_id: selectedExams,
          course_id: selectedCourse,
          student_id: selectedStudent,
          subject_id: item.subject_id,
          marks,
          status: item.status || null,
        }
      
        if (item.result_id) {
          putData.push({ ...common, result_id: item.result_id })
        } else {
          postData.push(common)
        }
      })
      
      // 🔁 PUT calls (with token)
      for (const putItem of putData) {
        const userCookie = Cookies.get('user')
        const user = userCookie ? JSON.parse(userCookie) : null
        const token = user?.token
  
        if (!token) {
          toast.error("Authorization token missing for update.")
          return
        }
  
        const putUrl = BASE_URL+`/results/update/${putItem.result_id}`
        const response = await axios.put(putUrl, putItem, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        })
        console.log('PUT response:', response.data)
      }
  
      if (postData.length > 0) {
        const addPayload = {
          exam_id: selectedExams,
          course_id: selectedCourse,
          student_id: selectedStudent,
          subjects: postData
        }
      
        
        const response = await ApiEndpoints.addStudentExamResult( addPayload)
  
        console.log('POST response:', response.data)
      }
  
      toast.success("Exam results submitted successfully.")
      setViewPreview(false)
    } catch (error) {
      const errorData = error.response?.data
      let errorMessage = 'Something went wrong. Please try again.'
  
      if (errorData?.errors) {
        errorMessage = Object.entries(errorData.errors)
          .map(([field, message]) => `${field} - ${message.join(', ')}`)
          .join(' | ')
      } else if (errorData?.message) {
        errorMessage = errorData.message
      }
  
      toast.error(errorMessage)
    }
  }
  
  // const handleSubmit = async (e) => {
  //   e.preventDefault()
  
  //   try {
  //     const putData = []
  //     const postData = []
  
  //     formData.forEach((item) => {
  //       const marks = item.number || item.grade || item.grade_number || null
  //       const common = {
  //         exam_id: selectedExams,
  //         course_id: selectedCourse,
  //         student_id: selectedStudent,
  //         subject_id: item.subject_id,
  //         marks,
  //         status: item.status || null,
  //       }
      
  //       if (item.result_id) {
  //         putData.push({ ...common, result_id: item.result_id })
  //       } else {
  //         postData.push(common)
  //       }
  //     })
      
  //     // 🔁 PUT calls (with token)
  //     for (const putItem of putData) {
  //       const userCookie = Cookies.get('user')
  //       const user = userCookie ? JSON.parse(userCookie) : null
  //       const token = user?.token
  
  //       if (!token) {
  //         toast.error("Authorization token missing for update.")
  //         return
  //       }
  
  //       const putUrl = `https://ttaapi.vibhumsoftware.com/api/results/update/${putItem.result_id}`
  //       const response = await axios.put(putUrl, putItem, {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           'Content-Type': 'application/json',
  //         },
  //       })
  //       console.log('PUT response:', response.data)
  //     }
  
  //     if (postData.length > 0) {
  //       const addPayload = {
  //         exam_id: selectedExams,
  //         course_id: selectedCourse,
  //         student_id: selectedStudent,
  //         subjects: postData
  //       }
      
        
  //       const response = await ApiEndpoints.addStudentExamResult( addPayload)
  
  //       console.log('POST response:', response.data)
  //     }
  
  //     toast.success("Exam results submitted successfully.")
  //     setViewPreview(false)
  //   } catch (error) {
  //     const errorData = error.response?.data?.message
  //     let errorMessage = 'Something went wrong. Please try again.'
  
  //     if (errorData?.errors) {
  //       errorMessage = Object.entries(errorData.errors)
  //         .map(([field, message]) => `${field} - ${message.join(', ')}`)
  //         .join(' | ')
  //     } else if (errorData?.message) {
  //       errorMessage = errorData.message
  //     }
  
  //     toast.error(errorMessage)
  //   }
  // }
  


  const formateScheme = (scheme) => {
    switch (scheme) {
      case 'grade':
        return 'Grade'
      case 'grade_number':
        return 'Grade and Number'
      case 'number':
        return 'Number'
      default:
        return ''
    }
  }

  const handleViewResult = () => {
    navigate(
      `/ExamMarksheet/${selectedStudent}/${selectedCourse}/${selectedClass}`,
    )
  }

  const selectedExam = exams.find((exam) => exam.id === Number(selectedExams))
  console.log('selectedExam', selectedExam)
  const markingScheme = selectedExam?.marking_scheme

  return (
    <>
      <style>
        {`
          /* Fix Typeahead dropdown z-index */
          .filter-card-container {
            overflow: visible !important;
            position: relative;
          }

          .rbt-menu {
            z-index: 1051 !important;
            position: absolute !important;
          }

          .rbt-menu.show {
            z-index: 1051 !important;
          }
        `}
      </style>
      <div 
        style={{ 
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          marginRight: '0px',
          marginBottom: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px',
        }}
      >
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px',
          }}
        >
        <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
          <div 
            className="d-flex justify-content-between align-items-center"
            style={{
              background: '#F3F4F6',
              paddingLeft: '28px',
              paddingRight: '28px',
              paddingTop: '12px',
              paddingBottom: '12px',
              overflow: 'visible',
              borderBottom: '1px solid #D1D3D4',
              width: '100%',
            }}
          >
            
            {/* Left: Title */}
            <div className="d-flex align-items-center gap-3">
              {/* School Logo */}
              <div style={{ 
                width: '40px', 
                height: '40px', 
                borderRadius: '50%', 
                overflow: 'hidden', 
                background: '#223843',
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                flexShrink: 0,
              }}>
                {!logoError ? (
                  <img 
                    src={logo} 
                    alt="School Logo" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                )}
              </div>
              
              <h3 
                className="m-0 fw-bold" 
                style={{ 
                  letterSpacing: '-0.02em',
                  overflow: 'visible',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontSize: 'clamp(18px, 2.5vw, 22px)',
                  color: '#223843',
                  lineHeight: '1.2',
                  fontFamily: 'Inter, system-ui, sans-serif',
                }}
              >
                Create {selectedStudentName ? `${selectedStudentName}'s` : ''} Marksheet
              </h3>
            </div>
            
            {/* Right: Profile Icon with Dropdown */}
            {!isMobile && (
              <ProfileDropdown logout={logout} />
            )}
          </div>
        </div>
        </div>
        <div
          className="container-fluid p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px',
          }}
        >
          {/* Filter Toggle Button */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex align-items-center gap-3">
              <button
                onClick={() => setShowFilterCard(!showFilterCard)}
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: showFilterCard ? '#223843' : '#ffffff',
                  border: '1px solid #D1D3D4',
                  color: showFilterCard ? '#ffffff' : '#223843',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.color = '#ffffff'
                  e.currentTarget.style.borderColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.transform = 'scale(1.05)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#ffffff'
                  e.currentTarget.style.color = showFilterCard ? '#ffffff' : '#223843'
                  e.currentTarget.style.borderColor = '#D1D3D4'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title={showFilterCard ? 'Hide Filters' : 'Show Filters'}
              >
                <BsFunnelFill size={20} />
              </button>
            </div>
          </div>

          {/* Modern Filter Section */}
          <div 
            style={{
              maxHeight: showFilterCard ? '1000px' : '0',
              overflow: showFilterCard ? 'visible' : 'hidden',
              transition: 'max-height 0.3s ease-in-out',
              marginBottom: showFilterCard ? '24px' : '0',
            }}
            className="filter-card-container"
          >
            {showFilterCard && (
              <Card 
                style={{
                  border: '1px solid #D1D3D4',
                  borderRadius: '12px',
                  backgroundColor: '#ffffff',
                  overflow: 'visible',
                  position: 'relative',
                }}
              >
                {/* Header */}
                <div 
                  style={{
                    background: '#ffffff',
                    padding: '20px',
                    borderBottom: '1px solid #F3F4F6',
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-3">
                      <div 
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <BsSearch style={{ color: '#ffffff', fontSize: '18px' }} />
                      </div>
                      <div>
                        <h5 className="m-0 fw-semibold text-start" style={{ color: '#111827', fontSize: '16px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          Search & Filter Exam Results
                        </h5>
                        <p className="m-0 mt-1" style={{fontSize: '13px', color: '#6b7280' }}>
                          Select course, class, student, and exam to add results
                        </p>
                      </div>
                    </div>
                    <div className="d-flex gap-2">
                      <button
                        onClick={handleRefresh}
                        style={{
                          width: '48px',
                          height: '48px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          border: 'none',
                          color: '#ffffff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1.05)'
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1)'
                        }}
                        title="Refresh"
                      >
                        <BsArrowClockwise size={20} />
                      </button>
                    </div>
                  </div>
                </div>

                <Card.Body className="p-4" style={{ backgroundColor: '#ffffff', overflow: 'visible', position: 'relative' }}>
                  <Row className="g-4 text-start">
                    {/* Course Selection */}
                    <Col xs={12} md={6} lg={3}>
                      <div style={{ position: 'relative' }}>
                        <label className="fw-semibold mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          Select Course
                        </label>
                        <Typeahead
                          id="course-select"
                          labelKey="name"
                          placeholder="Select Course"
                          onChange={(selected) => {
                            const course = selected[0]
                            if (course) {
                              handleCourseChange({ target: { value: course.id } })
                            } else {
                              handleCourseChange({ target: { value: '' } })
                            }
                          }}
                          options={courses}
                          selected={courses.filter(
                            (crs) => crs.id === Number(selectedCourse),
                          )}
                          inputProps={{
                            style: {
                              borderRadius: '8px',
                              border: '1px solid #D1D3D4',
                              fontSize: '14px',
                              height: '40px',
                              transition: 'all 0.2s ease',
                              backgroundColor: '#ffffff',
                              fontFamily: 'Inter, system-ui, sans-serif',
                            }
                          }}
                        />
                      </div>
                    </Col>

                    {/* Class Selection */}
                    <Col xs={12} md={6} lg={3}>
                      <div style={{ position: 'relative' }}>
                        <label className="fw-semibold mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          Select Class
                        </label>
                        <Typeahead
                          id="class-select"
                          labelKey="class_name"
                          onChange={(selected) => {
                            const cls = selected[0]
                            if (cls) {
                              handleClassChange({ target: { value: cls.id } })
                            } else {
                              handleClassChange({ target: { value: '' } })
                            }
                          }}
                          options={classes}
                          placeholder="Select Class"
                          selected={classes.filter(
                            (cls) => Number(cls.id) === Number(selectedClass),
                          )}
                          inputProps={{
                            style: {
                              borderRadius: '8px',
                              border: '1px solid #D1D3D4',
                              fontSize: '14px',
                              height: '40px',
                              transition: 'all 0.2s ease',
                              backgroundColor: '#ffffff',
                              fontFamily: 'Inter, system-ui, sans-serif',
                            }
                          }}
                        />
                      </div>
                    </Col>

                    {/* Student Selection */}
                    <Col xs={12} md={6} lg={3}>
                      <div style={{ position: 'relative' }}>
                        <label className="fw-semibold mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          Select Student
                        </label>
                        <Typeahead
                          id="student-select"
                          labelKey={(option) =>
                            `${option.name} - ${option.admission_number}` || ''
                          }
                          onChange={(selected) => {
                            const std = selected[0]
                            if (std) {
                              handleStudentChange({ target: { value: std.id } })
                            } else {
                              handleStudentChange({ target: { value: '' } })
                            }
                          }}
                          options={students}
                          placeholder="Select Student"
                          selected={
                            selectedStudent
                              ? students.filter(
                                  (st) => Number(st.id) === Number(selectedStudent),
                                )
                              : []
                          }
                          inputProps={{
                            style: {
                              borderRadius: '8px',
                              border: '1px solid #D1D3D4',
                              fontSize: '14px',
                              height: '40px',
                              transition: 'all 0.2s ease',
                              backgroundColor: '#ffffff',
                              fontFamily: 'Inter, system-ui, sans-serif',
                            }
                          }}
                        />
                      </div>
                    </Col>

                    {/* Exam Selection */}
                    <Col xs={12} md={6} lg={3}>
                      <div style={{ position: 'relative' }}>
                        <label className="fw-semibold mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          Select Exam
                        </label>
                        <Typeahead
                          id="exam-select"
                          labelKey="exam_name"
                          onChange={(selected) => {
                            const exm = selected[0]
                            if (exm) {
                              handleExamChange({ target: { value: exm.id } })
                              setDisabledMarking(true)
                            } else {
                              handleExamChange({ target: { value: '' } })
                              setDisabledMarking(false)
                            }
                          }}
                          options={exams}
                          placeholder="Select Exam"
                          selected={exams.filter(
                            (exm) => exm.id === Number(selectedExams),
                          )}
                          inputProps={{
                            style: {
                              borderRadius: '8px',
                              border: '1px solid #D1D3D4',
                              fontSize: '14px',
                              height: '40px',
                              transition: 'all 0.2s ease',
                              backgroundColor: '#ffffff',
                              fontFamily: 'Inter, system-ui, sans-serif',
                            }
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )}
          </div>

        {/* Exam Info Section */}
        {(disabledMarking || selectedExamId) && (
          <Card 
            style={{
              border: '1px solid #D1D3D4',
              borderRadius: '12px',
              backgroundColor: '#ffffff',
              marginBottom: '24px',
            }}
          >
            <Card.Body className="p-4">
              <Row className="align-items-center flex-wrap">
                <Col xs={12} md={4} className="mb-2 mb-md-0">
                  <div className="d-flex align-items-center gap-2">
                    <div 
                      style={{
                        width: '32px',
                        height: '32px',
                        borderRadius: '50%',
                        backgroundColor: '#223843',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <BsSearch style={{ color: '#ffffff', fontSize: '16px' }} />
                    </div>
                    <div>
                      <p className="mb-0" style={{ fontSize: '13px', color: '#6b7280', fontFamily: 'Inter, system-ui, sans-serif' }}>
                        <strong style={{ color: '#111827' }}>Marking Scheme:</strong>{' '}
                        {formateScheme(
                          exams.find((exm) => exm.id === Number(selectedExams))
                            ?.marking_scheme,
                        ) || '_'}
                      </p>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={4} className="mb-2 mb-md-0">
                  <div className="d-flex align-items-center gap-2">
                    <div 
                      style={{
                        width: '32px',
                        height: '32px',
                        borderRadius: '50%',
                        backgroundColor: '#10B981',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <BsSearch style={{ color: '#ffffff', fontSize: '16px' }} />
                    </div>
                    <div>
                      <p className="mb-0" style={{ fontSize: '13px', color: '#6b7280', fontFamily: 'Inter, system-ui, sans-serif' }}>
                        <strong style={{ color: '#111827' }}>Passing Marks:</strong>{' '}
                        {exams.find((exm) => exm.id === Number(selectedExams))
                          ?.passing_marks ?? '__'}
                      </p>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={4}>
                  <Button
                    variant="link"
                    className="text-decoration-none fw-bold p-0"
                    onClick={handleViewResult}
                    style={{ color: '#223843', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}
                  >
                    <FaClipboardList style={{ marginRight: '6px' }} /> View Marksheet
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        )}
        {openTable &&  selectedStudent && subjects.length > 0 && (
          <Card 
            style={{
              border: '1px solid #D1D3D4',
              borderRadius: '12px',
              backgroundColor: '#ffffff',
              overflow: 'hidden',
            }}
          >
            <Card.Body className="p-0">
              <Table 
                striped 
                bordered 
                hover 
                responsive
                style={{
                  marginBottom: '0',
                }}
              >
                <thead style={{ backgroundColor: '#F3F4F6' }}>
                  <tr>
                    <th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>S.NO</th>
                    <th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Subject</th>
                    {(markingScheme === 'number' ||
                      markingScheme === 'grade_number') && (
                      <th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Marks in Number</th>
                    )}

                    {(markingScheme === 'grade' ||
                      markingScheme === 'grade_number') && (
                      <th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Marks in Grade</th>
                    )}
                    <th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {subjects.map((item, index) => (
                    <tr 
                      className="text-start" 
                      key={item.id}
                      style={{ 
                        backgroundColor: index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)',
                        transition: 'background-color 0.2s ease',
                        borderBottom: '1px solid #E5E7EB',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(37, 99, 235, 0.06)'
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)'
                      }}
                    >
                      <td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>{index + 1}</td>
                      <td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>{item.subject_name}</td>
                      {(markingScheme === 'number' ||
                        markingScheme === 'grade_number') && (
                        <td>
                          <Form.Control
                            type="number"
                            placeholder="Enter marks in number"
                            value={formData[index]?.number?.trim() || ""}
                            disabled={!!formData[index]?.grade || ""}
                            onChange={(e) =>
                              handleInputChange(e, index, 'number')
                            }
                          />
                        </td>
                      )}
                      {(markingScheme === 'grade' ||
                        markingScheme === 'grade_number') && (
                        <td>
                          <Form.Control
                            type="text"
                            placeholder="Enter marks in grade"
                            value={formData[index]?.grade?.trim() ||""}
                            disabled={!!formData[index]?.number}
                            onChange={(e) =>
                              handleInputChange(e, index, 'grade')
                            }
                          />
                        </td>
                      )}
                      <td>
                        <Form.Check
                          type="switch"
                          id={`switch-${index}`}
                          label={
                            formData[index]?.status === 'pass' ? 'Pass' : 'Fail'
                          }
                          checked={formData[index]?.status === 'pass'}
                          disabled
                          onChange={() => handleToggle(index)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
            <Card.Footer className="p-4" style={{ backgroundColor: '#ffffff', borderTop: '1px solid #F3F4F6' }}>
              <div className="d-grid">
                <Button
                  variant="info"
                  className="text-white fw-bold rounded-3 py-2"
                  onClick={() => setViewPreview(true)}
                  style={{ 
                    letterSpacing: '2px', 
                    fontSize: '16px',
                    backgroundColor: '#223843',
                    border: 'none',
                    transition: 'all 0.2s ease',
                    fontFamily: 'Inter, system-ui, sans-serif',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#223843'
                    e.currentTarget.style.transform = 'scale(1.02)'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#223843'
                    e.currentTarget.style.transform = 'scale(1)'
                  }}
                >
                  Show Preview
                </Button>
              </div>
            </Card.Footer>
          </Card>
        )}
        </div>
      </div>

      <Modal size="xl" show={viewPreview} onHide={() => setViewPreview(false)}>
        <Modal.Header className="text-white" style={{backgroundColor: '#223843'}} closeButton>
          <Modal.Title>Preview Marksheet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>S. No</th>
                <th>Subject</th>
                {(markingScheme === 'number' ||
                  markingScheme === 'grade_number') && <th>Marks in Number</th>}

                {(markingScheme === 'grade' ||
                  markingScheme === 'grade_number') && <th>Marks in Grade</th>}
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {subjects.map((item, index) => (
                <tr className="text-start" key={item.id}>
                  <td> {index + 1} </td>
                  <td>{item.subject_name || '-'} </td>
                  {/* <td>{formData[index]?.number || '-'}</td>
                  <td>{formData[index]?.grade || '-'}</td> */}
                  {(markingScheme === 'number' ||
                    markingScheme === 'grade_number') && (
                    <td>{formData[index]?.number?.trim() || '-'}</td>
                  )}
                  {(markingScheme === 'grade' ||
                    markingScheme === 'grade_number') && (
                    <td>{formData[index]?.grade?.trim() || '-'}</td>
                  )}

                  <td>
                    {formData[index]?.status
                      ? formData[index].status.charAt(0).toUpperCase() +
                        formData[index].status.slice(1)
                      : '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <Modal.Footer>
            <Button 
              variant="secondary" 
              onClick={() => setViewPreview(false)}
              className="rounded-pill px-4"
            >
              Edit Marksheet
            </Button>
            <Button
              variant="success"
              className="text-white rounded-pill px-4"
              onClick={handleSubmit}
            >
              Save Student Result
            </Button>
          </Modal.Footer>
        </Modal.Body>
      </Modal>
    </>
  )
}

